import { render, staticRenderFns } from "./LastResults.vue?vue&type=template&id=0809f232&"
import script from "./LastResults.vue?vue&type=script&lang=js&"
export * from "./LastResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports